@for (promo of promotionalTexts; track promo) { @if (promo && promo !== '') {
<div class="promotional-text-container">
  @if ( promotionLocation === 'CART' || promotionLocation === 'CAROUSEL' || promotionLocation === 'NORMALCAROUSEL') {
  <app-tooltip-text
    class="badge badge-primary"
    [tooltipContent]="promo"
    [content]="promo"
    [charactersLimit]="charactersLimit"
    placement="bottom"
    [ngClass]="[promotionLocation === 'CART' ? 'cart-promo' : 'text-truncate', hasMemoField === 'true' ? '' : 'noMemo']"
  >
  </app-tooltip-text>
  } @else {
  <app-tooltip-text
    class="badge badge-primary text-truncate"
    [tooltipContent]="'product.promo' | cxTranslate"
    [content]="promo"
    [promotionLocation]="promotionLocation"
    placement="bottom"
  >
  </app-tooltip-text>
  }
</div>
} }
